import React, { useEffect, useState } from 'react'
import { Box, FormControl, Button, TextField, Typography, IconButton, Link, InputAdornment } from '@mui/material'
import LeftSide from './LeftSide'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import '../../assets/extraStyle.css'
import { Images } from '../../global/GloblImages'
import email from '../../assets/common/images/email.png'
import password from '../../assets/common/images/password.png'
import { ArrowOutward, LogoutOutlined, Visibility, VisibilityOff, VisibilityOffOutlined } from '@mui/icons-material'
import { ApiGetClientEntityId, ApiRegionVenues, ApiUsersLogin } from '../../apiService/Core/Apicall';
import { toast, ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from 'react-router-dom';
import Loading from '../../Components/Loader/Loading';
import { useDispatch, useSelector } from 'react-redux';
import login1 from '../../assets/images/styleimages/login1.png'
import login2 from '../../assets/images/styleimages/login2.png'
import Domains from '../../global/constants/domain';
import { setRegion } from '../../global/config/Reducer/RegionSlice';
import { red } from '@mui/material/colors';
import { setallclientEntityIds } from '../../global/config/Reducer/WholeGroupSlice';
import storage from '../../utils/storage';
import { restoreSession } from '../RestoreSession/restoresession';


const getIconColorByDomain = () => {
    const domain = window.location.hostname;

    if (domain.includes(Domains.ALDI)) return '#001F79';
    if (domain.includes(Domains.BLOOMS)) return '#1A2D8D';
    if (domain.includes(Domains.MM)) return '#2ECC71';

    return '#ADB792';
};
function Login() {
    const primary_color = getIconColorByDomain()
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const [showpassword, setshowpassword] = useState(false)
    const { MMLogo } = Images()
    const isnotMM = window.location.hostname.includes('client')
    const [showportalName, setShowPortalName] = useState<React.ReactNode>(null);


    const loading = useSelector((state: any) => state.loader.isLoading);
    const formik = useFormik({
        initialValues: {
            emailId: '',
            password: '',
        },
        validationSchema: Yup.object({
            emailId: Yup.string()
                .email('Invalid email format')
                .required('Email is required'),
            password: Yup.string()
                .min(6, 'Password must be at least 6 characters')
                .required('Password is required'),
        }),
        onSubmit: async (values) => {
            setShowPortalName("")
            try {
                const response = await ApiUsersLogin(values)
                if (response?.requiresTwoFactor) {
                    if (response?.roleName === "clientadmin" || response?.roleName === "areaManager" || response?.roleName === "venueadmin") {
                        navigate('/verify', {
                            state: {
                                username: values?.emailId?.trim(),
                                password: values?.password?.trim(),
                                tempToken: response?.tempToken
                            }
                        })
                        return
                    } else if (response?.roleName === "admin" || response?.roleName === "superadmin" || response?.roleName === "editor") {
                        toast.error("Invalid Access");
                        setShowPortalName(
                            <div>
                                Please Login to{" "}
                                <a
                                    href={process.env.REACT_APP_ADMIN_SITE}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Admin Portal
                                </a>
                            </div>
                        );
                    } else if (response?.roleName === "shopper") {
                        toast.error("Invalid Access");
                        setShowPortalName(
                            <div>
                                Please Login to{" "}
                                <a
                                    href={process.env.REACT_APP_SHOPPER_SITE}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Shopper Portal
                                </a>
                            </div>
                        );
                    }
                    else {
                        toast.error("Invalid Access")
                    }
                    return
                }
                storage.setItem('token', response.token)
                localStorage.setItem('token', response.token)
                if (
                    response.userDetails.role.roleName === 'clientadmin' &&
                    window.location.hostname.includes('client') &&
                    response.otherDetails.ClientGroupName.clientGroupName !== "ALDI" &&
                    response.otherDetails.ClientGroupName.clientGroupName !== "BLOOMS"
                ) {
                    const groupName =
                        response.otherDetails.ClientGroupName.clientGroupName;

                    // session storage
                    storage.setItem('ClientGroupName', groupName);

                    // local storage
                    localStorage.setItem('ClientGroupName', groupName);
                }

                if (
                    response.userDetails.role.roleName !== 'clientadmin' &&
                    window.location.hostname.includes('client') &&
                    response.otherDetails.clientGroupName !== "ALDI" &&
                    response.otherDetails.clientGroupName !== "BLOOMS"
                ) {
                    const groupName =
                        response.otherDetails.clientGroupName;

                    // session storage
                    storage.setItem('ClientGroupName', groupName);

                    // local storage
                    localStorage.setItem('ClientGroupName', groupName);
                }
                const clientgroupname = storage.getItem('ClientGroupName')
                // if (storage.getItem("token") && response.userDetails.role.roleName === 'clientadmin' ? (clientgroupname === "" && (response.otherDetails.ClientGroupName.clientGroupName === "TRANSPORT")) : (clientgroupname === "MM" && (response?.otherDetails?.clientGroupName === "TRANSPORT"))) {
                //     storage.setItem('userRole', response.userDetails.role.roleName)
                //     response.userDetails.role.roleName === 'clientadmin' && storage.setItem('clientId', response.otherDetails.ClientID)
                //     storage.setItem('userData', JSON.stringify(response.userDetails));
                //     const response2 = response.userDetails.role.roleName === 'clientadmin' && await ApiGetClientEntityId(response.otherDetails.ClientID)
                //     storage.setItem("ratingJson",response2.data[0][0].ratingJson)
                //     storage.setItem('clientEntityId', response.userDetails.role.roleName === 'clientadmin' ? response2.data[0][0].clientEntityId : response.otherDetails.clientEntityId)
                //     response.userDetails.role.roleName === 'clientadmin' && storage.setItem('clientEntityName', response2.data[0][0].entityName)
                //     storage.setItem('ActiveTask', "Dashboard")
                //     navigate("/maindashboard/dashboard");
                // }
                if ((storage.getItem("token") && response.userDetails.role.roleName === 'clientadmin') ? (response.otherDetails.ClientGroupName.clientGroupName === clientgroupname) : (response?.otherDetails?.clientGroupName === clientgroupname)) {
                    storage.setItem('userRole', response.userDetails.role.roleName)
                    localStorage.setItem('userRole', response.userDetails.role.roleName)
                    response.userDetails.role.roleName === 'clientadmin' && storage.setItem('clientId', response.otherDetails.ClientID)
                    response.userDetails.role.roleName === 'clientadmin' && localStorage.setItem('clientId', response.otherDetails.ClientID)
                    storage.setItem('userData', JSON.stringify(response.userDetails));
                    storage.setItem('userOtherData', JSON.stringify(response.otherDetails));
                    localStorage.setItem('userData', JSON.stringify(response.userDetails));
                    localStorage.setItem('userOtherData', JSON.stringify(response.otherDetails));
                    response?.otherDetails?.areas?.[0]?.areaId && storage.setItem('areaId', response?.otherDetails?.areas?.[0]?.areaId)
                    response?.otherDetails?.areas?.[0]?.areaName && storage.setItem('areaName', response?.otherDetails?.areas?.[0]?.areaName)
                    response.userDetails.role.roleName !== 'clientadmin' && storage.setItem('cssNPS', response?.otherDetails?.canClientSeeNPSScore)
                    // response?.otherDetails?.venues?.[0]?.venueName && storage.setItem('cssNPS', response?.otherDetails?.venues?.[0]?.canClientSeeNPSScore)
                    storage.setItem('INF', response?.otherDetails?.hideFixIt);
                    storage.setItem('ISC', response?.otherDetails?.hideSiteComparison);
                    response?.userDetails?.role?.roleName !== 'clientadmin' && response?.otherDetails?.clientGroupName === 'ALDI' && storage.setItem('clientEntityName', response?.otherDetails?.clientEntityName)
                    const response2 = response.userDetails.role.roleName === 'clientadmin' && await ApiGetClientEntityId(response.otherDetails.ClientID)
                    response2 && storage.setItem("ratingJson", response2.data[0][0]?.ratingJson)
                    const allClientEntityIds = response2?.data?.[0]
                        ?.sort((a: any, b: any) => a.entityCode === "SON" ? Number(a.clientEntityId) - Number(b.clientEntityId) : Number(b.clientEntityId) - Number(a.clientEntityId))
                        ?.map((item: any) => item.clientEntityId)
                        ?.join(",") || "";
                    dispatch(setallclientEntityIds(allClientEntityIds))
                    storage.getItem('userRole') === 'clientadmin' && storage.setItem('dwc', response2.data[0][0]?.isAllowDownloadWithoutComments);
                    storage.getItem('userRole') === 'clientadmin' && storage.setItem('INF', response2.data[0][0]?.hideFixIt);
                    storage.getItem('userRole') === 'clientadmin' && storage.setItem('ISC', response2.data[0][0]?.hideSiteComparison);
                    storage.getItem('userRole') === 'clientadmin' && storage.setItem('cssNPS', response2.data[0][0]?.canClientSeeNPSScore);
                    storage.setItem('clientEntityId', response.userDetails.role.roleName === 'clientadmin' ? response2.data[0][0].clientEntityId : response.otherDetails.clientEntityId)
                    response.userDetails.role.roleName === 'clientadmin' && storage.setItem('clientEntityName', response2.data[0][0].entityName)
                    storage.setItem('ActiveTask', "Dashboard")
                    navigate("/maindashboard/dashboard");
                }
                else {
                    alert("Invalid Acess")
                }

                // toast.success(response.message)
                if (storage.getItem("clientEntityId") && (storage.getItem('ClientGroupName') === 'ALDI' || storage.getItem('ClientGroupName') === 'BLOOMS') && response.userDetails.role.roleName === 'clientadmin' ? (response.otherDetails.ClientGroupName.clientGroupName === clientgroupname) : (response?.otherDetails?.clientGroupName === clientgroupname)) {
                    const data = `?clientEntityId=${storage.getItem("clientEntityId")}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`
                    const response3 = await ApiRegionVenues(data)
                    dispatch(setRegion(response3?.data))
                }

            }
            catch (error: any) {
                alert(error)
                console.log(error)
                // toast.error(error)
            }
            // Handle login logic here
        },
    });

    useEffect(() => {
        const clientGroupName2 = localStorage.getItem('ClientGroupName');
        // storage.clear()
        const clientGroupName = (window.location.hostname.includes('aldi')) ? "ALDI" : window.location.hostname.includes('blooms') ? "BLOOMS" : "MM"
        storage.setItem('ClientGroupName', clientGroupName)
        if (!clientGroupName2) { localStorage.setItem('ClientGroupName', clientGroupName) }
    }, [])


    // const dispatch = useDispatch();
    // const navigate = useNavigate();

    useEffect(() => {
        restoreSession(dispatch, navigate);
    }, []);
    return (
        <Box className='w-100 login h-100'>
            <ToastContainer/>
            {/* <Box className='col-md-9 d-none d-md-block h-100 px-0 px-4 py-4'>
                <LeftSide />
            </Box> */}
            <Box className='d-flex flex-column align-items-center'>
                <Box component='img' className='mb-2' width='50%' zIndex={2} src={MMLogo} height='auto' alt='logo' />
                <Box className='w-100 h-100  px-3  d-flex align-items-stretch flex-column' gap={7} zIndex={2}>
                    <Box className='mt-2 d-flex flex-column ' gap={2}>
                        <Typography className='text-center mt-2' fontWeight='bolder' fontSize={{ md: '32px', xs: '24px', }}>Welcome</Typography>
                        <Typography className='text-center' color='#161B1E80' fontSize={{ xs: '14px', md: '18px' }}>Get started using your email.</Typography>
                    </Box>
                    <form onSubmit={formik.handleSubmit} className='d-flex input-border bg-main p-4  flex-column' style={{ borderRadius: '30px', borderWidth: '0px', borderBottomRightRadius: '50px' }}>
                        <Typography className='text-start mb-2 txt-white' fontWeight={900} variant='h5'>Login</Typography>
                        <FormControl fullWidth className="mb-3">
                            <label className='label txt-white'>Email ID <span className='text-danger'>*</span></label>
                            <TextField fullWidth
                                name='emailId'
                                sx={{
                                    "& .MuiOutlinedInput-root": {
                                        borderRadius: "10px !important"
                                    }
                                }}
                                value={formik.values.emailId}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}


                                error={formik.touched.emailId && Boolean(formik.errors.emailId)}
                                helperText={formik.touched.emailId && formik.errors.emailId}
                            />
                        </FormControl>
                        <Box sx={{ marginBottom: '50px' }}>
                            <FormControl fullWidth>
                                <label className='label txt-white'>Password <span className='text-danger'>*</span></label>
                                <Box className='align-items-start d-flex'>
                                    <TextField
                                        name='password'
                                        fullWidth
                                        type={showpassword ? 'text' : 'password'}
                                        value={formik.values.password}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        sx={{
                                            // borderRight:'none !important',
                                            "& .MuiOutlinedInput-root": {
                                                borderRadius: "10px !important",
                                                borderTopRightRadius: '0px !important',
                                                borderBottomRightRadius: '0px !important',
                                            },
                                            borderRight: "none !important"
                                        }}
                                        error={formik.touched.password && Boolean(formik.errors.password)}
                                        helperText={formik.touched.password && formik.errors.password}
                                    />
                                    <Box onClick={() => { setshowpassword((prev) => !prev) }} flex={1} className='d-flex justify-content-center align-items-center border-right px-2' sx={{ height: "56px", border: '1px solid red', borderLeft: 'none', borderTopRightRadius: '10px', borderColor: isnotMM ? "black !important" : "white !important", cursor: 'pointer', borderBottomRightRadius: '10px' }}>
                                        {showpassword ?
                                            <VisibilityOff sx={{ color: isnotMM ? "black !important" : "white !important" }} style={{ pointerEvents: "none" }} /> :
                                            <Visibility sx={{ color: isnotMM ? "black !important" : "white !important" }} style={{ pointerEvents: "none" }} />
                                        }
                                    </Box>
                                </Box>
                            </FormControl>

                        </Box>
                        <Link href='/ForgotPassword' className='text-light mt-4' fontSize='14px' width='50%' onClick={() => storage.setItem("auth", "forgotpassword")}>Forgotten your password?</Link>
                        <Box component='img' src={login1} height='120px' width='120px' className='login1'>
                        </Box>
                        <IconButton type='submit' className='bg-white submit-button'>
                            <ArrowOutward sx={{ color: primary_color }} />
                        </IconButton>
                        {/* <Button type='submit' sx={{ width: { xs: '100%', md: '75%' } }} className='btn btn-main  mt-4 py-2 border-10'>Login <LogoutOutlined /></Button> */}
                    </form>
                    {showportalName && (<Box className='my-2'>
                        {showportalName}
                    </Box>
                    )}
                    <Box className=''>
                        <Typography className='text-center' variant='subtitle2'>By signing in, you agree to our</Typography>
                        <Link href='/' className='text-main text-center mt-1 d-flex align-items-center justify-content-center' fontSize='14px'>Terms and Conditions and Privacy Policy</Link>
                    </Box>
                </Box>
                <Box className='w-100 login1' sx={

                    !isnotMM
                        ? {
                            filter:
                                'brightness(0) saturate(100%) invert(10%) sepia(94%) saturate(3569%) hue-rotate(214deg) brightness(86%) contrast(97%)',
                            opacity: 0.2,
                        }
                        : {}
                } component='img' src={login2} height='fit-content' bgcolor='transparent'>
                </Box>
            </Box>
            {/* {loading && <Loading/>} */}
            {isnotMM && (
                <Box className='d-flex mt-2 align-itenms-center justify-content-center gap-3'>
                    <Button onClick={() => { window.open(process.env.REACT_APP_API_ALDI) }} className='btn-main'>ALDI LOGIN</Button>
                    <Button onClick={() => { window.open(process.env.REACT_APP_API_BLOOMS) }} className='btn-main'>BLOOMS LOGIN</Button>
                </Box>
            )}

        </Box>

    )
}

export default Login
